import React from 'react';
import PropTypes from 'prop-types';
import Category from './Category';
import ListGroup from 'react-bootstrap/Listgroup';

const Categories = (props) => {
    if (!props.categories) {
        return (
            <div />);
    }

    return (
        <div>
            <ListGroup>
                {props.categories.map(category => (
                    <Category
                        key={category.id}
                        category={category}
                        onClick={props.onClick}
                        currentCategory={props.currentCategory}
                    />
                ))}
            </ListGroup>
        </div>
    );
};

Categories.propTypes = {
    categories: PropTypes.array,
    currentCategory: PropTypes.object,
    onClick: PropTypes.func
};

export default Categories;
